/*!
  Machina, by Koding Themes
  recomendations.js
  https://kodingthemes.com
*/

document.addEventListener("DOMContentLoaded", function () {
  dynamicRecommendationsFunction(null);
});
document.addEventListener("shopify:section:load", function (e) {
  var target = e.target;
  dynamicRecommendationsFunction(target);
});

function dynamicRecommendationsFunction(target) {
  var recommendedSections = document.querySelectorAll(
    ".dynamic-recommendation-section"
  );
  recommendedSections.forEach(function (recommendedSection) {
    if (target != null) {
      var targetSection = target.querySelector(
        ".dynamic-recommendation-section"
      );
      if (targetSection == recommendedSection) {
        sliderRecommendedLoop(recommendedSection);
      }
    } else {
      sliderRecommendedLoop(recommendedSection);
    }
  });
}

function sliderRecommendedLoop(recommendedSection) {
  var productRecomendationBody = recommendedSection.querySelector(".featured-related");
  if (productRecomendationBody == null) return;

  var sectionId = productRecomendationBody.dataset.sectionid;
  var url = recommendedSection.dataset.url;
  var sliderSelector = productRecomendationBody;

  var getProducts = async function() {
    var recommendURL = url.trim();
    var response = await fetch(recommendURL);
    if (!response.ok) throw new Error("Failed to load recommendations: " + response.status);
    return response.json();
  };

  getProducts()
    .then(function(data) {
      var products = data.products;

      if (!products || products.length === 0) {
        recommendedSection.classList.add("d-none");
        return;
      }

      if (products.length < 3) {
        sliderSelector.classList.add("w-100");
      }

      // Fetch all product HTML in parallel, then insert in correct order
      var fetchPromises = products.map(function(product) {
        return fetch("/products/" + product.handle + "?view=recommended-product")
          .then(function(res) {
            if (!res.ok) throw new Error("Failed to load product: " + product.handle);
            return res.text();
          });
      });

      return Promise.all(fetchPromises).then(function(htmlResults) {
        // Insert in order (beforeend preserves product sequence)
        htmlResults.forEach(function(productRow) {
          sliderSelector.insertAdjacentHTML("beforeend", productRow);
        });

        // Apply card style
        var cardStyle = recommendedSection.dataset.cardstyle;
        if (cardStyle) {
          var cards = productRecomendationBody.querySelectorAll(".product-card-new-design");
          cards.forEach(function(card) {
            card.classList.add(cardStyle);
          });
        }

        // Apply image aspect ratio
        var imageRatio = recommendedSection.dataset.imageratio;
        if (imageRatio) {
          var images = productRecomendationBody.querySelectorAll("img");
          images.forEach(function(image) {
            image.classList.add(imageRatio);
          });
        }

        setTimeout(function() {
          recommendedSection.classList.remove("recommendations-placeholder-active");
        }, 1000);
        recommendedSection.classList.remove("d-none");
        sliderRecommendedProducts(sectionId, sliderSelector);

        document.dispatchEvent(new CustomEvent(
          "shopify-recommendation:init-product-grid",
          { detail: { recommendations: products } }
        ));
      });
    })
    .catch(function() {
      recommendedSection.classList.add("d-none");
    });
}
// recommended products slider
function sliderRecommendedProducts(sectionId, productRecomendationBody) {
  //row formatting
  var element = productRecomendationBody;
  var slider2 = tns({
    container: productRecomendationBody,
    items: 1,
    slideBy: "1",
    nav: false,
    speed: 400,
    gutter: 20,
    mode: "carousel",
    prevButton: "#" + sectionId + " .js-slider-sites-prev",
    nextButton: "#" + sectionId + " .js-slider-sites-next",
    navPosition: "bottom",
    autoplayButtonOutput: false,
    mouseDrag: true,
    autoplay: false,
    controls: true,
    freezable: true,
    touch: true,
    preventScrollOnTouch: "force",
    rewind: true,
    lazyload: false,
    center: false,
    loop: false,
    controlsContainer: "#" + sectionId + " .recommendations-slider-controls",
    onInit(info) {
        info.container.setAttribute('tabindex', -1);
        info.controlsContainer.setAttribute('tabindex', '-1');
        info.nextButton.setAttribute('tabindex', 0);
        info.prevButton.setAttribute('tabindex', 0);
    },
    responsive: {
      320: {
        items: 1
      },
      640: {
        items: 1
      },
      768: {
        items: 2
      },
      1024: {
        items: 3
      }
    }
  });
  //slider2.goTo(1);
  slider2.refresh();
}
